import "core-js/modules/es.array.reverse.js";
var _class, _ToggleSplitterController;
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
import { action, computed, makeObservable } from "mobx";
import Icon from "../../../../Styled/Icon";
import MapNavigationItemController from "../../../../ViewModels/MapNavigation/MapNavigationItemController";
export let ToggleSplitterController = (_class = (_ToggleSplitterController = class ToggleSplitterController extends MapNavigationItemController {
  constructor(viewState) {
    super();
    this.viewState = viewState;
    makeObservable(this);
  }
  get glyph() {
    if (this.active) {
      return Icon.GLYPHS.splitterOn;
    }
    return Icon.GLYPHS.compare;
  }
  get viewerMode() {
    return undefined;
  }
  get visible() {
    return super.visible && this.viewState.terria.currentViewer.canShowSplitter;
  }
  get disabled() {
    var _this$viewState$curre;
    const toolIsDifference = ((_this$viewState$curre = this.viewState.currentTool) === null || _this$viewState$curre === void 0 ? void 0 : _this$viewState$curre.toolName) === "Difference";
    return this.viewState.isToolOpen && toolIsDifference;
  }
  get active() {
    return this.viewState.terria.showSplitter;
  }
  activate() {
    this.viewState.terria.showSplitter = true;
    super.activate();
  }
  deactivate() {
    this.viewState.terria.showSplitter = false;
    super.deactivate();
  }
}, _defineProperty(_ToggleSplitterController, "id", "split-tool"), _ToggleSplitterController), _applyDecoratedDescriptor(_class.prototype, "visible", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "visible"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "disabled", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "disabled"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "active", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "active"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "activate", [action], Object.getOwnPropertyDescriptor(_class.prototype, "activate"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "deactivate", [action], Object.getOwnPropertyDescriptor(_class.prototype, "deactivate"), _class.prototype), _class);